import { render } from "./AccountActivationForm.vue?vue&type=template&id=a1f0e89e&ts=true"
import script from "./AccountActivationForm.vue?vue&type=script&lang=ts"
export * from "./AccountActivationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__